export default {
  firebase: {
    apiKey: 'AIzaSyBZJmUnbSqufRL64CSzdJMpy3hlRshd-9Q',
    authDomain: 'juggertrainer.firebaseapp.com',
    databaseURL: 'https://juggertrainer.firebaseio.com',
    projectId: 'juggertrainer',
    storageBucket: 'juggertrainer.appspot.com',
    messagingSenderId: '103859061629',
    appId: '1:103859061629:web:eff53ba99a8251f65cc214',
    measurementId: 'G-KN7W5GRDM4',
  },
};
